import SODIntlProvider from "./sod-intl-provider.jsx";

export default SODIntlProvider;